exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spec[data-v-6249515e]{color:#474747;font-size:14px}.spec .yen[data-v-6249515e]{font-size:11px}", ""]);

// exports
